import React, { MouseEvent, ReactNode } from 'react';
import { Text } from '@/components/typography';
import { useTranslations } from 'next-intl';

export interface OffersNotFoundProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const OffersNotFound = ({ children, ...props }: OffersNotFoundProps) => {
  const t = useTranslations('Oferta');
  return (
    <Text align="center" size="md">
      {t('Ofertas não encontradas')}.
    </Text>
  );
};

export default OffersNotFound;
